// import { Button } from "@/components/ui/button";
// import { useQuiz } from "@/hooks/useQuiz";
// import useSound from "use-sound";
// import correct from "/correct.mp3";
// import incorrect from "/incorrect.mp3";
// import { useHistory } from "./hooks/useHistory";

import { Home } from "@/components/Home";
import { Quiz } from "./components/quiz";
import { useQuiz } from "./hooks/useQuiz";
import { Review } from "./components/review";

function App() {
  const {
    isQuizStarted,
    startQuizWithSettings,
    currentQuestion,
    onClick,
    choice,
    choices,
    settings,
    setSettings,
    summary,
    onQuizEnd,
    showReview,
    questionsAttempted,
    onReviewEnd,
    wordHistory,
  } = useQuiz();
  const title = "كلمات القرآن";

  const onQuizStart = () => {
    startQuizWithSettings(settings);
  };

  return (
    <div className="min-h-screen bg-themeBackground dark:bg-gray-800 dark:text-gray-100">
      <div className="mx-auto max-w-xl p-5">
        <header className="flex justify-end">
          <h1 className="font-arabic text-3xl text-themeTitleText dark:text-gray-100">
            {title}
          </h1>
        </header>

        {isQuizStarted ? (
          <Quiz
            currentQuestion={currentQuestion}
            choices={choices}
            onClick={onClick}
            choice={choice}
            onQuizEnd={onQuizEnd}
            wordHistory={wordHistory}
          />
        ) : showReview ? (
          <Review
            questionsAttempted={questionsAttempted.length || 0}
            onReviewEnd={onReviewEnd}
          />
        ) : (
          <Home
            onQuizStart={onQuizStart}
            settings={settings}
            setSettings={setSettings}
            summary={summary}
          />
        )}
      </div>
    </div>
  );
}

export default App;
